<template>
  <v-tooltip
    top
    content-class="custom-tooltip"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        outlined
        class="border"
        :class="{
          'border-nitro' : cycle.started,
          'mt-n7' : isMobile
        }"
        :disabled="!cycle.started"
        small
        color="nitro"
        v-on="on"
        @click="onClick"
      >
        <v-icon style="font-size: 1.5em">
          fa fa-arrow-right
        </v-icon>
      </v-btn>
    </template>
    Ir para o {{ cycle.cycle_name }}
  </v-tooltip>
</template>

<script>
import { mapMutations } from 'vuex';
import { studyNowRouteName } from '@/student/constants/routes';

export default {
    props:{
        cycle: {
            required: true,
            type: Object,
        }
    },
    methods: {
        ...mapMutations(['SET_CYCLE']),
        onClick(){
            this.SET_CYCLE(this.cycle)
            this.$router.push({ 
                name: studyNowRouteName,
                query: { cycle_config_id: this.cycle.id }
            })
        }
    }
}
</script>
<style scoped>
.custom-tooltip {
   opacity: 1 !important;
  background-color: #f0f0f5 !important;
  color: #828282 !important;
}
</style>